<template>
  <a href="https://gatoreviews.com" style="display: inline-block;">
    <img
      v-if="white"
      src="https://gatoreviews.s3.eu-west-3.amazonaws.com/common/emails/new/GTR_Logo-white.png"
      style="display: block; height: 32px;"
      :width="width"
    />
    <img
      v-else
      src="https://gatoreviews.s3.eu-west-3.amazonaws.com/common/emails/new/GTR_Logo-blue.png"
      style="display: block; height: 32px;"
      :width="width"
    />
  </a>
</template>

<script>
export default {
  props: {
    white: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: 'auto',
    },
  },
}
</script>
